import { React, useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

export default function ContentInput(props) {
  const { value, setValue, placeholder } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [byte, setByte] = useState(0);
  const TextareaRef = useRef(null);

  useEffect(() => {
    if (!TextareaRef.current) return;
    TextareaRef.current.style.height = 'auto';
    TextareaRef.current.style.height = TextareaRef.current.scrollHeight + 'px';
  }, [value])

  useEffect(() => {
    const combined = value !== '' ? value + '\n' + UNSUBSCRIBE_TEXT : value;
    setByte(checkValueByte(combined));
  }, [value])

  function handleChange(e) {
    let text = e.target.value;
    let combined = text !== '' ? text + '\n' + UNSUBSCRIBE_TEXT : text;
    let byte = checkValueByte(combined);

    if (byte <= 2000) {
      setByte(byte);
      setValue(text);
    }
  }

  function getMessageType(text) {
    let bytes = 0;
    for (let i = 0; i < text.length; i++) {
      bytes += text.charCodeAt(i) > 127 ? 2 : 1;
    }
    return bytes > 90 ? 'LMS' : 'SMS';
  }

  function checkValueByte(str) {
    //UTF8 기준 Byte Length 계산
    let byteLength = 0;

    for (let i = 0, strLength = str.length; i < strLength; i++) {
      let code = str.charCodeAt(i);
      if (code < 0x0080) {
        //[0x0000, 0x007F]
        byteLength += 1;
      }
      else if (code < 0x0800) {
        //[0x0080, 0x07FF]
        byteLength += 2;
      }
      else if (code < 0xD800) {
        //[0x0800, 0xD7FF]
        byteLength += 3;
      }
      else if (code < 0xDC00) {
        //[0xD800, 0xDBFF]
        let codeNext = str.charCodeAt(++i);

        if (i < strLength && codeNext >= 0xDC00 && codeNext <= 0xDFFF) {
          //followed by [0xDC00, 0xDFFF]
          byteLength += 4;
        }
        else {
          throw new Error("UCS-2 String malformed");
        }
      }
      else if (code < 0xE000) {
        //[0xDC00, 0xDFFF]
        throw new Error("UCS-2 String malformed");
      }
      else {
        //[0xE000, 0xFFFF]
        byteLength += 3;
      }
    }
    return byteLength;
  }


  return (
    <TopLevelWrapper>
      <InputBox>
        <Input
          ref={TextareaRef}
          rows={1}
          placeholder={placeholder}
          value={value}
          onChange={handleChange} />
        {
          value !== '' &&
          <UnsubscribeText>{UNSUBSCRIBE_TEXT}</UnsubscribeText>
        }
      </InputBox>
      <BottomWrapper>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.primary} hover='default'>{getMessageType(value !== '' ? value + '\n' + UNSUBSCRIBE_TEXT : value)}</Text>
        <ByteWrapper>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='default'>{value === '' ? 0 : byte}</Text>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='default'>/</Text>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.primary} hover='default'>2000 Byte</Text>
        </ByteWrapper>
      </BottomWrapper>
    </TopLevelWrapper>
  )
}

export const UNSUBSCRIBE_TEXT = '무료수신거부 080-870-1659';

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 5px;

  overflow: hidden;
`;

const InputBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: stretch;

  box-sizing: border-box;
  width: 100%;
  min-height: 210px;

  padding: 15px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};

  transition: border-color 0.3s ease-in-out;
`;

const Input = styled.textarea`
  width: 100%;

  padding: 0;
  border: none;

  font-family: NotoSansKR-Medium;
  font-size: 14px;
  line-height: 20px;

  color: ${props => props.theme.text};
  background-color: transparent;

  outline: none;
  resize: none;
  overflow: hidden;

  ::placeholder {
    color: ${props => props.theme.line};
  }
`;

const UnsubscribeText = styled.p`
  margin: 20px 0 0 0;

  font-family: NotoSansKR-Medium;
  font-size: 14px;
  line-height: 20px;

  color: ${props => props.theme.line};

  pointer-events: none;
`;

const BottomWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;

  width: 100%;
`;

const ByteWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: flex-start;

  width: 100%;

  gap: 4px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.hover};
  }
`;